export enum PRODUCTS {
    BOOKING = "booking",
    LESSON = "lesson",
}
